import { useState } from 'react';
import { NameInputWrap } from './YS.styles';

const YSNameInput = ({ onSubmit }) => {
    const [name, setName] = useState('');

    const handleSubmit = () => {
        if (!name.trim()) {
            alert('이름을 입력해주세요.');
            return;
        }
        onSubmit(name.trim());
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSubmit();
    };

    return (
        <NameInputWrap>
            <div className='logo'>110기 첫 엠티</div>
            <div className='desc'>차량 배정</div>
            <input
                type="text"
                placeholder="이름을 입력하세요"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={handleKeyDown}
                autoFocus
            />
            <button onClick={handleSubmit}>시작하기</button>
        </NameInputWrap>
    );
};

export default YSNameInput;
